module.exports = __webpack_public_path__ + "assets/logo-min-white.d57530b4f458fe66d69892ed689b4dc8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/logo-min-white.png
 ** module id = 369
 ** module chunks = 0
 **/